import React, { useContext, useRef } from "react";

import { useFlags } from "launchdarkly-react-client-sdk";

import {
  TaskDetailsV2,
  TaskDetailsV3,
} from "@fartherfinance/frontend/api/Tasks/Types";
import { TaskId } from "@fartherfinance/frontend/api/Types";

import { SelectedNotificationContext } from "../NotificationPreview/NotificationPreview";
import TaskDetailsEmbeddedV3 from "@src/multiCustodian/pages/Advisor/Tasks/TaskDetails/TaskDetailsEmbeddedV3";
import TaskDetailsWorkflowEmbedded from "@src/multiCustodian/pages/Advisor/TaskWorkflows/TaskDetailsWorkflow/TaskDetailsWorkflowEmbedded";

import styles from "./NotificationDetails.module.css";

const NotificationDetails: React.FC = () => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const selectedNotification = useContext(SelectedNotificationContext);
  const { enableTaskWorkflows } = useFlags();

  const handleScrollToBottom = (): void => {
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: containerRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  const handleConditionCheck = (
    taskDetails: TaskDetailsV2 | TaskDetailsV3
  ): boolean => {
    return !taskDetails.isDeleted;
  };

  if (selectedNotification && selectedNotification.resourceType === "task") {
    return (
      <div ref={containerRef} className={styles.container}>
        <div className={styles.content}>
          {enableTaskWorkflows ? (
            <TaskDetailsWorkflowEmbedded
              taskId={selectedNotification.resourceId as TaskId}
            />
          ) : (
            <TaskDetailsEmbeddedV3
              taskId={selectedNotification.resourceId as TaskId}
              onTaskDetailsReady={handleScrollToBottom}
              onReadyConditionCheck={handleConditionCheck}
            />
          )}
        </div>
      </div>
    );
  }

  return null;
};

export default NotificationDetails;
